export enum ExchangeTradeTypes {
    MARKET = 'MARKET',
    LIMIT = 'LIMIT',
    STOP_LIMIT = 'STOP_LIMIT',
    STOP_MARKET = 'STOP_MARKET',
    TRAILING_STOP = 'TRAILING_STOP',
    TAKE_PROFIT_LIMIT = 'TAKE_PROFIT_LIMIT',
    TAKE_PROFIT_MARKET = 'TAKE_PROFIT_MARKET',
}

export type TradeActions =
    | {
          type: 'SET_TRADE_TYPE';
          payload: ExchangeTradeTypes;
      }
    | {
          type: 'SET_LEVERAGE';
          payload: string;
      }
    | {
          type: 'SET_COLLATERAL';
          payload: string;
      }
    | {
          type: 'SET_LIMIT_PRICE';
          payload: string;
      }
    | {
          type: 'TOGGLE_IS_SHORT';
      };

export type TradeStateType = {
    tradeType: ExchangeTradeTypes;
    isShort: boolean;
    leverage: string;
    collateral: string;
    limitPrice: string;
};

export type TradeFunctions = {
    toggleIsShort: () => void;
    setTradeType: (tradeType: ExchangeTradeTypes) => void;
    setLeverage: (leverage: string) => void;
    setCollateral: (collateral: string) => void;
    setLimitPrice: (limitPrice: string) => void;
};

export type TradeTypes = TradeStateType & TradeFunctions;
